import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=2e38e2ad&scoped=true&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddress.vue?vue&type=style&index=0&id=2e38e2ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38e2ad",
  null
  
)

export default component.exports